import { create } from "zustand";

import type { Device } from "@/types";

interface TrackingState {
  selectedDevice: Device | null;
  setSelectedDevice: (device: Device | null) => void;
}

export const useTrackingStore = create<TrackingState>((set) => ({
  selectedDevice: null,
  setSelectedDevice: (selectedDevice) => set({ selectedDevice }),
}));
